import { Currency,  useCurrenciesQueryQuery, useExchangeRatesQuery } from '../generated/graphql';
import { createContext, useEffect } from 'react';
import React,{ useState } from 'react';
import { useCallback } from 'react';
import {useUserContext} from "./user-context";
import { useDaybookContext } from './Daybook/DayBookContext';
import { useContext } from 'react';

export const ExchangeRatesContext = createContext<ExchangeRatesContextValue|null>(null);

export type ExchangeRatesContextValue = {
  targetCurrency: Currency|null,
  calcExchangeRate: null |( (from:Currency,amount:number,qty?:number) => number),
  calcSiteExchangeRate: null | ((from:Currency,amount:number,qty?:number) => number),
  options:Currency[],
  systemOptions:Currency[],
  exchangeRates:any
}

export const useExchangeRatesContext = ()=>{
  return useContext<ExchangeRatesContextValue|null>(ExchangeRatesContext);
}

// options = things that should be shown
// systemOptions = everything that exists (important for some exchange rate bits)
export const ExchangeRatesContextProvider = ({currencyId,children,options,systemOptions=null,fixedExchangeRates})=>{
  console.log('[EXC] rendering with',currencyId,options);
  const user = useUserContext();
  const parentExchangeRates = React.useContext(ExchangeRatesContext);
  const daybook = useDaybookContext();
  const currencyQry = useCurrenciesQueryQuery({skip:!user || !user?.isLoggedIn});
  const qry = useExchangeRatesQuery({skip:!user || !user?.isLoggedIn});
  //const [exchangeRates,setExchangeRates] = useState<any>();
  const setExchangeRates = useCallback((newEr=>{
    setState((state)=>{
      const p = {...state};
      p.exchangeRates = newEr;
      console.log('[EXC] state set to ',p);
      return p;
    });
  }),[]);
  const [state,setState] = useState<ExchangeRatesContextValue>({
    targetCurrency:null,
    calcExchangeRate:null,
    calcSiteExchangeRate:null,
    options:options,
    systemOptions:systemOptions,
    exchangeRates:null
  });
  console.log('[EXC] State',state);
  const exchangeRates = state.exchangeRates;
  const calcExchangeRate = useCallback((from:Currency,amount:number,qty?:number):number=> {
    if(!from) return Math.floor(amount*(qty?qty:1));
    if(!state.targetCurrency) return Math.floor(amount*(qty?qty:1));
    if(!exchangeRates) return Math.floor(amount*(qty?qty:1));
    const fromId = ''+from.id;
    console.log('[EXC] converting',{rates:exchangeRates,from:from.id,to:state.targetCurrency?.id,er:exchangeRates[''+from.id]?exchangeRates[''+from.id][state.targetCurrency?.id]:0,ers:exchangeRates,target:state?.targetCurrency});
    if(from.id == state.targetCurrency.id) return Math.floor(amount*(qty??1));
    if(!exchangeRates[fromId]) return 0;
    return Math.floor(exchangeRates[fromId][state.targetCurrency.id]*amount*(qty??1));
  },[exchangeRates,state?.targetCurrency]);

  const calcSiteExchangeRate = useCallback((from:Currency,amount:number,qty?:number):number => {
    if(parentExchangeRates && parentExchangeRates.calcExchangeRate) {
      return parentExchangeRates.calcExchangeRate(from,amount*(qty??1));
    }
    return calcExchangeRate(from,amount);
  },[state?.targetCurrency,parentExchangeRates]);
  useEffect(()=>{
    if(!currencyQry.data) return;
    if(currencyQry.data?.currencies?.length) {
      currencyQry.data.currencies.forEach((v:Currency|null)=>{
        if(!v) return;
        if(v.id == currencyId) {
          setState(
            (oldValue)=>{
              const nV = Object.assign({},oldValue);
              console.log('[EXC] USEEFFECT1',oldValue,v);
              nV.targetCurrency = v;

              if(oldValue.options) {
                let optionsHasTarget = false;
                console.log('[EXC] OLDVALUES OPTIONS',oldValue);
                oldValue.options.forEach((option)=>{
                  if(option?.id == currencyId) {
                    optionsHasTarget = true;
                  }
                });
                if(!optionsHasTarget) {
                  nV.options.push(v);
                }
              }
              console.log('[EXC] setting',nV);
              return nV;
          });
        }
      })
    }

  },[currencyQry.data,currencyId]);
  useEffect(()=>{
    setState((oldValue:ExchangeRatesContextValue)=>{
      console.log('[EXC] update currencies',oldValue,currencyQry.data);
      const nvv:ExchangeRatesContextValue = {...oldValue};
      nvv.options = currencyQry?.data?.currencies??[];
      nvv.systemOptions = currencyQry?.data?.currencies??[];
      return nvv;
    })
  },[currencyQry.data]);
  useEffect(()=> {
    // ensure target currency is in options
    if(!options) return;
    setState((v)=>{
      const nV = Object.assign({},v);
      nV.options = [...options];
      if(options) {
        let optionsHasTarget = false;
        const targetCurrencyId = v?.targetCurrency?.id;
        options?.forEach((option)=>{
          if(option.id == targetCurrencyId) {
            optionsHasTarget = true;
          }
        });
        console.log('[EXC] SET TARGET CURRENCY',options,v.options,optionsHasTarget,v.targetCurrency);
        if(!optionsHasTarget && v?.targetCurrency) {
          nV.options.push(v.targetCurrency);
        }
      }
      return nV;
    });
  },[options,state.targetCurrency]);

  useEffect(()=>{
    // populate default currency onload
    setState((state)=>{
      if(!daybook?.defaultSiteCurrency) return state;
      if(state.targetCurrency) return state;
      const s = {...state};
      s.targetCurrency = daybook?.defaultSiteCurrency??null;
      return s;
    });
  },[daybook?.defaultSiteCurrency]);
  useEffect(() => {
    if(fixedExchangeRates) {
      // these override exchange rates
      const er = {};
      // build a simple [from_id][to_id] matrix
      // use 1/rate for [to_id][from_id] if it isn't specified
      fixedExchangeRates.forEach((rate)=>{
        const fromId = ''+rate.from;
        const toId = ''+rate.to;
        if(!er[fromId]) er[fromId] = {};
        er[fromId][toId] = rate.rate;
        if(!er[toId]) er[toId] = {};
        if(!er[toId][fromId]) {
          er[toId][fromId] = 1/rate.rate;
        }
      });
      console.log('[EXC] using FIXED exchange rates',er);
      setExchangeRates(er);
      return;
    }
    if(qry?.data?.exchangeRates) {
      const er = {};
      // build a simple [from_id][to_id] matrix
      // use 1/rate for [to_id][from_id] if it isn't specified
      qry.data.exchangeRates.forEach((v)=>{
        if(!v) return;
        const from = String(v?.from?.id);
        const to = String(v?.to?.id);
        if(!er[from]) { er[from] = {}; }
        er[from][to] = v.rate;
        if(!er[to]) { er[to] = {}; }
        if(!er[to][from]) {
          er[to][from] = 1/(v?.rate??1);
        }
      });
      console.log('[EXC] using LOCALEX global exchange rates',er);
      setExchangeRates(er);
    }
  },[qry?.data?.exchangeRates,fixedExchangeRates]);

  // weird, but hopefully works?
  state.calcExchangeRate = calcExchangeRate;
  state.calcSiteExchangeRate = calcSiteExchangeRate;
console.log('ERCP',currencyId,state);
  return <ExchangeRatesContext.Provider value={state}>{children}</ExchangeRatesContext.Provider>
};